import PropTypes from 'prop-types';
import BetslipButtonViewImpl from './betslip-button-view.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * BetslipButton view displaying button with amount of items in betslip.
 *
 * @class BetslipButtonView
 * @name view
 * @memberof Mojito.Modules.BetslipButton
 */

/**
 * BetslipButtonView prop types.
 *
 * @property {number} [betslipItemsCount = 0] - Amount of betslip items.
 * @property {boolean} [showImage = false] - True if button should show image instead of items count, false - otherwise.
 * @property {Function} [onClick = () => {}] - Callback function executes on betslip button click.
 * @property {boolean} [isHighlighted = false] - True if button should be in highlighted state (e.g. When there are active selections in betslip), otherwise - false.
 * @property {boolean} [isLoading = false] - True if button should be in loading state (e.g. When bets are still being fetched), otherwise - false.
 * @property {boolean} [disabled = false] - Flag controlling the button's disabled state. A disabled button is not clickable and has additional styles applied to it.
 * @property {Function} [onCloseFreebetsTip = () => {}] - Callback for closing Free bets tip button.
 * @property {boolean} [showFreebetsTip] - True if Free bets tip should be shown in betslip button.
 * @property {boolean} [showFreebetsIcon] - True if Free bets icon should be shown in betslip button.
 * @property {boolean} [showOveraskImage] - True if button should show overask image, will override showImage.
 * @property {node} [children] - Children that will be rendered inside betslip button.
 *
 * @memberof Mojito.Modules.BetslipButton.view
 */
const propTypes = {
    betslipItemsCount: PropTypes.number,
    onClick: PropTypes.func,
    isHighlighted: PropTypes.bool,
    isLoading: PropTypes.bool,
    showImage: PropTypes.bool,
    disabled: PropTypes.bool,
    onCloseFreebetsTip: PropTypes.func,
    showFreebetsTip: PropTypes.bool,
    showFreebetsIcon: PropTypes.bool,
    showOveraskImage: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const defaultProps = {
    betslipItemsCount: 0,
    onClick: noop,
    isHighlighted: false,
    isLoading: false,
    showImage: false,
    disabled: false,
    onCloseFreebetsTip: noop,
};

export default UIView('BetslipButtonView', BetslipButtonViewImpl, propTypes, defaultProps);
